import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import _ from 'lodash';
import { Fragment, useMemo, useState } from 'react';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';
import Badge from '../Badges/Badge';
import CheckBox from '../Inputs/Checkbox';
import SearchInput from '../Inputs/SearchInput';
import './dropdown-filter.css';


export default function DropdownFilter({label = '', options = [], onChange, value = []}) {
  const [searchText, setSearchText] = useState('');
  const filteredOptions = searchText ? options.filter(item => item.label.toLowerCase().indexOf(searchText.toLowerCase()) > -1) : options;

  const labelColorClass = useMemo(() => `text-${value.length > 0 ? 'blue' : 'slate'}-500`, [value.length]);
  const length = value.length;
  const toggleOption = (id) => {
    const newSelectedIds = value.includes(id) ? value.filter(selectedId => selectedId !== id) : [...value, id];
    onChange(newSelectedIds);
  }
  const [selectedGroupId, setSelectedGroupId] = useState('');
  const isGroupOpen = (id) => selectedGroupId === id;
  const optionsGroups = options && options.some(option => option.group) && Object.entries(_.groupBy(options, x => x.group));
  const toggleGroup = (id) => setSelectedGroupId(selectedGroupId === id ? '' : id);
  const DropdownOption = ({option}) => (
  <div className='filter-label-wrapper' onClick={() => toggleOption(option.id)}><CheckBox isChecked={value.includes(option.id)}/><div className='filter-label'>{option.label}</div></div>)
  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button className="border-transparent bg-transparent cursor-pointer">
        <div className={`inline-flex w-full justify-center items-center gap-x-1.5 rounded-md bg-transparent border-transparent shadow-none text-sm font-semibold p:0 ${labelColorClass}`}>
          {label} {length > 0 && <Badge label={length} color="info" compact/>}
          <ChevronDownIcon className="-mr-1 h-5 w-5" aria-hidden="true" />
        </div>
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none max-h-80 overflow-auto">
          <div className="flex flex-col gap-1">
            {options.length > 10 && <SearchInput borderless value={searchText} onChange={value => setSearchText(value)}/>}
            {
              filteredOptions.length === 0 && !optionsGroups && !searchText
                ? <div className='p-3 pb-4 text-neutral-400'>No options</div>
                : optionsGroups && !searchText ? optionsGroups.map(group => 
                <Fragment key={group[0]}><div className='filter-label-wrapper filter-group-label-wrapper' onClick={() => toggleGroup(group[0])}><div className='filter-label'>{group[0]}</div>{isGroupOpen(group[0]) ? <BsChevronUp/> : <BsChevronDown/>}</div>
                  {isGroupOpen(group[0]) && group[1].map(option => <DropdownOption option={option} key={option.id}/>)}
                </Fragment>
              ) : filteredOptions.map(option => <DropdownOption option={option} key={option.id}/>
                
              )}
              {searchText && filteredOptions.length === 0 && <div className='p-3 pb-4 text-neutral-400'>No results</div>}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
